import BaseAPI from './BaseAPI';

export class DashboardAPI extends BaseAPI {

	async create(name) {
		return this.request(`/-/dashboard`, 'POST', {name});
	}
	async update(dashboard) {
		return this.request(`/-/dashboard`, 'PUT', {dashboard: dashboard.toJS()});
	}
	async delete(id) {
		return this.request(`/-/dashboard`, 'DELETE', {id});
	}

	async getPresentationPages() {
		return this.request(`/-/presentation`, 'GET');
	}
	async savePresentationPage(page) {
		return this.request(`/-/presentation`, 'POST', page);
	}
	async deletePresentationPage(page) {
		return this.request(`/-/presentation`, 'DELETE', page);
	}
	
	async getDashboards(dashboardIds) {
		return this.request(`/-/dashboard/${JSON.stringify(dashboardIds)}`, 'GET');
	}


}
